export const CHECKOUT_URL =
  'https://hip-hop-dance-instructor-ready.impultienda.ar/checkout'

export const PRODUCT_NAME = 'Hip Hop Dance Instructor Ready'

export const PRICE_USD = 27.0

export function trackInitiateCheckout() {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'InitiateCheckout', {
      content_name: 'Hip Hop Dance Instructor Ready — 6-in-1 System',
      value: PRICE_USD,
      currency: 'USD',
    })
  }
}
